module.exports = __webpack_public_path__ + "static/media/Eagle.115fd5a0.png";